import { render } from "./GenderEiLevelCompareChart.vue?vue&type=template&id=5796e1fc&scoped=true"
import script from "./GenderEiLevelCompareChart.vue?vue&type=script&lang=js"
export * from "./GenderEiLevelCompareChart.vue?vue&type=script&lang=js"

import "./GenderEiLevelCompareChart.vue?vue&type=style&index=0&id=5796e1fc&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5796e1fc"]])

export default __exports__